// @flow
import _ from 'lodash'
import React, { Component } from 'react'

type Props = {|
  value: string
|}

export default class TextWithNewlines extends Component<Props> {
  render() {
    return (
      <div>
        {this.props.value
          .replace('\r', '')
          .split('\n')
          .map((line, index) => (
            <div key={index}>{_.isEmpty(line) ? <br /> : line}</div>
          ))}
      </div>
    )
  }
}
